"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMenu = exports.DropdownMenuList = exports.DropdownMenuButton = void 0;
var core_1 = require("@emotion/core");
var styled_1 = __importDefault(require("@emotion/styled"));
var React = __importStar(require("react"));
var react_use_1 = require("react-use");
var __1 = require("..");
var theme_1 = require("../theme");
var Viewports_1 = require("./Viewports");
var noop = function () { return undefined; };
var DropdownMenuButton = function (_a) {
    var children = _a.children, _b = _a.onClose, onClose = _b === void 0 ? noop : _b, props = __rest(_a, ["children", "onClose"]);
    var ref = React.useRef(null);
    (0, react_use_1.useClickAway)(ref, onClose);
    return (React.createElement(Button, __assign({ ref: ref }, props, { variation: "secondary" }),
        children,
        React.createElement(__1.ArrowDropDownIcon, { size: 16 })));
};
exports.DropdownMenuButton = DropdownMenuButton;
var DropdownMenuList = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(DropDownWrapper, { pipelineActions: props.pipelineActions },
        React.createElement(ListWrapper, null,
            React.createElement(StyledList, __assign({}, props), children))));
};
exports.DropdownMenuList = DropdownMenuList;
var DropDownWrapper = styled_1.default.div(function (_a) {
    var pipelineActions = _a.pipelineActions;
    return (0, core_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    z-index: 1;\n    overflow: hidden;\n    background: ", ";\n    top: 100%;\n    width: 100%;\n    border-radius: 2px;\n    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.17);\n    padding-top: ", ";\n    padding-bottom: ", ";\n\n    ", "\n\n    ", " {\n      min-width: 220px;\n      max-width: 244px;\n      max-height: 400px;\n    }\n\n    ", " {\n      ", "\n    }\n  "], ["\n    position: absolute;\n    z-index: 1;\n    overflow: hidden;\n    background: ", ";\n    top: 100%;\n    width: 100%;\n    border-radius: 2px;\n    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.17);\n    padding-top: ", ";\n    padding-bottom: ", ";\n\n    ", "\n\n    ", " {\n      min-width: 220px;\n      max-width: 244px;\n      max-height: 400px;\n    }\n\n    ", " {\n      ", "\n    }\n  "])), theme_1.theme.colors.surface200, theme_1.theme.space.space8, theme_1.theme.space.space8, pipelineActions &&
        "\n      border-radius: ".concat(theme_1.theme.space.space4, ";\n      width: 340px;\n    "), Viewports_1.mediaDesktop, Viewports_1.mediaHuge, pipelineActions &&
        "\n        right: 0px;\n        max-width: 400px;\n        width: max-content;\n      ");
});
var ListWrapper = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  transition: opacity 4s ease;\n"], ["\n  display: flex;\n  flex-direction: column;\n  transition: opacity 4s ease;\n"])));
var StyledList = styled_1.default.ol(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  outline: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n"], ["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  outline: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n"])));
exports.DropdownMenu = styled_1.default.div(function () { return "\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 2;\n\n  > label:first-of-type {\n    margin-bottom: ".concat(theme_1.theme.space.space4, ";\n  }\n\n  > button {\n    margin-bottom: ").concat(theme_1.theme.space.space4, ";\n  }\n"); });
var Button = styled_1.default.button(function () { return "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: ".concat(theme_1.theme.colors.surface200, ";\n  color: ").concat(theme_1.theme.colors.contentPrimary, ";\n  border: 1px solid ").concat(theme_1.theme.colors.n80, ";\n  padding: 0 ").concat(theme_1.theme.space.space16, ";\n  height: ").concat(theme_1.theme.space.space40, ";\n  font-size: ").concat(theme_1.theme.fontSizes.body, ";\n  line-height: ").concat(theme_1.theme.fontSizes.body, ";\n  text-align: left;\n  border-radius: 2px;\n  cursor: pointer;\n  ").concat(Viewports_1.mediaDesktop, " {\n    max-width: 244px;\n  }\n  :hover {\n    border-color: ").concat(theme_1.theme.colors.n300, ";\n  }\n  :focus {\n    outline: none;\n    background: ").concat(theme_1.theme.colors.n50, ";\n  }\n"); });
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=DropdownMenu.js.map